<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex justify-content-end">
            <span data-dismiss="modal" (click)="closeModal()">
                <i class="material-icons">close</i>
            </span>
        </div>
        <div class="text-center mb-4">
            <span class="modal-title">{{ title | uppercase }}</span>
        </div>
        <div class="loader-block" *ngIf="showRequestLoader">
            <app-loader-css></app-loader-css>
        </div>
        <form role="form" [formGroup]="form" novalidate [ngStyle]="{'display': showRequestLoader ? 'none' : 'block'}">
            <div class="form-group">
                <input type="text" class="form-control" placeholder="{{ 'CRUD_MODAL.FIRST_NAME' | translate }}"
                    [ngClass]="{'is-valid': firstNameControl.valid, 'is-invalid': firstNameControl.invalid && firstNameControl.touched}"
                    formControlName="firstName">
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': firstNameControl.invalid && firstNameControl.touched ? 'block' : 'none'}">
                    <span>{{ 'CRUD_MODAL.FIRST_NAME_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <input type="text" class="form-control" placeholder="{{ 'CRUD_MODAL.LAST_NAME' | translate }}"
                    [ngClass]="{'is-valid': lastNameControl.valid, 'is-invalid': lastNameControl.invalid && lastNameControl.touched}"
                    formControlName="lastName">
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': lastNameControl.invalid && lastNameControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CRUD_MODAL.LAST_NAME_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <input type="email" class="form-control" placeholder="{{ 'CRUD_MODAL.EMAIL' | translate }}"
                    [ngClass]="{'is-valid': emailControl.valid, 'is-invalid': emailControl.invalid && emailControl.touched}"
                    formControlName="email">
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': emailControl.invalid && emailControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CRUD_MODAL.EMAIL_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">

                <ngx-intl-tel-input [ngClass]="{'tel-input-placeholder-center': true}"
                    customPlaceholder="{{ 'CRUD_MODAL.PHONE' | translate }}" [separateDialCode]="separateDialCode"
                    [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.All]" [selectFirstCountry]="true" [maxLength]="maxLength"
                    [phoneValidation]="true" [numberFormat]="PhoneNumberFormat.International" name="phone"
                    formControlName="phone">
                </ngx-intl-tel-input>
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': phoneControl.invalid && phoneControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CRUD_MODAL.PHONE_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <ng-select [dropdownPosition]="'bottom'" placeholder="{{ 'CRUD_MODAL.CUSTOMER' | translate }}"
                    [items]="customerList" bindValue="id" [searchable]="true" bindLabel="name"
                    formControlName="customer" [multiple]="false" required>
                </ng-select>
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': customerControl.invalid && customerControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CRUD_MODAL.CUSTOMER_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <ng-select [dropdownPosition]="'bottom'" placeholder="{{ 'CRUD_MODAL.ORG' | translate }}"
                    [items]="orgList" bindValue="id" [searchable]="true" bindLabel="name" formControlName="organization"
                    [multiple]="false" required>
                </ng-select>
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': orgControl.invalid && orgControl.touched ? 'block' : 'none'}">
                    <span invalid-feedback> {{ 'CRUD_MODAL.ORG_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <ng-select [dropdownPosition]="'bottom'" placeholder="{{ 'CRUD_MODAL.PERM' | translate }}"
                    [items]="permissionList" [searchable]="false" formControlName="permission" [multiple]="true"
                    required>
                </ng-select>
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': permissionControl.invalid && permissionControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CRUD_MODAL.PERM_ERR' | translate }} </span>
                </div>
            </div>

            <div class="form-group">
                <textarea rows="4" class="form-control" placeholder="{{ 'CRUD_MODAL.NOTES' | translate }}"
                    formControlName="notes"></textarea>
            </div>
        </form>
        <div class="d-flex flex-column align-items-center" *ngIf="!showRequestLoader">
            <div class="text-center invalid-feedback mb-2" [ngStyle]="{'display': existUserErr ? 'block' : 'none'}">
                <span> {{ 'CRUD_MODAL.EXIST_USER' | translate }} </span>
            </div>
            <div class="text-center invalid-feedback mb-2" [ngStyle]="{'display': incorrectOrgErr ? 'block' : 'none'}">
                <span> {{ 'CRUD_MODAL.INCORRECT_ORG' | translate }} </span>
            </div>
            <div class="text-center invalid-feedback mb-2"
                [ngStyle]="{'display': incorrectPermissionErr ? 'block' : 'none'}">
                <span> {{ 'CRUD_MODAL.INCORRECT_PERMISSION' | translate }} </span>
            </div>
            <div class="text-center invalid-feedback mb-2" [ngStyle]="{'display': showOtherError ? 'block' : 'none'}">
                <span> {{ otherError }} </span>
            </div>
            <button type="button" class="modal-ok-btn" [disabled]="!enableSaveBtn()" ngbAutofocus (click)="save()">{{
                'CONSTANTS.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</ng-template>